import React from "react";

export default function RadioLabelInput({
  label,
  name,
  options = [],        // [{label: "Yes", value: true}, {label: "No", value: false}]
  value,
  onChange,
  required = false,
  error,
  disabled = false,
}) {
  return (
    <div className="w-full flex flex-col">

      {/* Label + Options Inline */}
      <div className="flex items-center gap-4">

        {/* Label */}
        <span className="text-gray-700 font-medium text-sm whitespace-nowrap">
          {label} {required && <span className="text-red-500">*</span>}
        </span>

        {/* Radio Options Immediately After Label */}
        <div className="flex items-center gap-4">
          {options.map((opt) => (
            <label key={String(opt.value)} className="flex items-center gap-1">
              <input
                type="radio"
                name={name}
                checked={value === opt.value}
                onChange={() => onChange(opt.value)}
                disabled={disabled}
                className="w-4 h-4 accent-black cursor-pointer"
              />
              <span className="text-sm">{opt.label}</span>
            </label>
          ))}
        </div>

      </div>

      {/* Error */}
      {error && <p className="text-red-500 text-xs">{error}</p>}
    </div>
  );
}
